import AccordionLists from "components/accordion";
import Footer from "components/global/footer";
import HeroBanner from "components/herobanner";
import { Helmet } from "react-helmet";

const surpeatsAdvantages = [
  {
    id: 0,
    title: "Cost Savings",
    description:
      "Enjoy high-quality food at discounted prices, making it a budget-friendly choice.",
    icon: (
      <svg
        width="75"
        height="75"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="37.6063" cy="37.0573" r="36.9418" fill="white" />
        <g clip-path="url(#clip0_1_1546)">
          <path
            d="M48.1222 25.2071C48.6096 25.2071 49.0046 24.812 49.0046 24.3247V21.3834C49.0046 20.8961 48.6096 20.501 48.1222 20.501H26.3563C25.869 20.501 25.4739 20.8961 25.4739 21.3834V24.6739C25.4739 25.1612 25.869 25.5563 26.3563 25.5563H32.6272C34.6353 25.5563 36.176 26.2885 37.1106 27.5602H26.3563C25.869 27.5602 25.4739 27.9553 25.4739 28.4426V31.384C25.4739 31.8713 25.869 32.2664 26.3563 32.2664H38.0303C37.5731 34.9199 35.6065 36.5778 32.5331 36.5778H26.3563C25.869 36.5778 25.4739 36.9729 25.4739 37.4602V41.3584C25.4739 41.6046 25.5768 41.8397 25.7578 42.0068L37.8947 53.2101C38.0577 53.3605 38.2713 53.4441 38.4932 53.4441H44.5642C45.3675 53.4441 45.753 52.4581 45.1627 51.9132L34.0678 41.6718C39.6931 41.4997 43.7113 37.7454 44.2389 32.2664H48.1222C48.6096 32.2664 49.0046 31.8713 49.0046 31.384V28.4426C49.0046 27.9553 48.6096 27.5602 48.1222 27.5602H43.8066C43.5502 26.7116 43.1977 25.9244 42.7586 25.2071H48.1222Z"
            fill="#3A7789"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_1546">
            <rect
              width="23.5308"
              height="37.6492"
              fill="white"
              transform="translate(25.4739 18.1479)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: 1,
    title: "Reduce Food Waste",
    description:
      "Help combat food waste by rescuing surplus items that would otherwise go to landfills.",
    icon: (
      <svg
        width="75"
        height="75"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="37.7109" cy="37.0573" r="36.9418" fill="#3A7789" />
        <path
          d="M49.0112 26.7702H42.6839V25.5695C42.6789 24.7193 42.3397 23.9052 41.7396 23.303C41.4406 23.003 41.0852 22.7651 40.6939 22.603C40.3026 22.441 39.8831 22.3579 39.4596 22.3586H35.0615C34.638 22.3579 34.2185 22.441 33.8272 22.603C33.4359 22.7651 33.0805 23.003 32.7816 23.303C32.1864 23.9074 31.8521 24.7212 31.8507 25.5695V26.7702H25.5234C25.2551 26.7702 24.9977 26.8768 24.808 27.0666C24.6182 27.2563 24.5116 27.5137 24.5116 27.782C24.5116 28.0504 24.6182 28.3077 24.808 28.4975C24.9977 28.6872 25.2551 28.7938 25.5234 28.7938H27.4391V44.6592C27.4336 45.2741 27.55 45.884 27.7816 46.4536C28.0131 47.0233 28.3553 47.5414 28.7882 47.978C29.671 48.8429 30.8577 49.3273 32.0935 49.3271H42.3736C43.6095 49.3273 44.7962 48.8429 45.6789 47.978C46.1119 47.5414 46.454 47.0233 46.6856 46.4536C46.9171 45.884 47.0335 45.2741 47.028 44.6592V28.7938H48.9572C49.2256 28.7938 49.483 28.6872 49.6727 28.4975C49.8625 28.3077 49.9691 28.0504 49.9691 27.782C49.9691 27.5137 49.8625 27.2563 49.6727 27.0666C49.483 26.8768 49.2256 26.7702 48.9572 26.7702H49.0112ZM33.9013 25.5695C33.9014 25.4138 33.9324 25.2596 33.9926 25.116C34.0529 24.9724 34.1411 24.8422 34.2521 24.7331C34.4751 24.5125 34.7749 24.3868 35.0885 24.3823H39.4866C39.6445 24.3813 39.8009 24.4118 39.9469 24.4721C40.0928 24.5323 40.2253 24.621 40.3365 24.7331C40.5571 24.9561 40.6828 25.2558 40.6873 25.5695V26.7702H33.9418L33.9013 25.5695ZM35.6956 42.5816C35.6956 42.9394 35.5535 43.2826 35.3005 43.5356C35.0475 43.7886 34.7043 43.9307 34.3465 43.9307C33.9887 43.9307 33.6456 43.7886 33.3926 43.5356C33.1396 43.2826 32.9974 42.9394 32.9974 42.5816V35.256C32.9974 34.8982 33.1396 34.5551 33.3926 34.3021C33.6456 34.0491 33.9887 33.9069 34.3465 33.9069C34.7043 33.9069 35.0475 34.0491 35.3005 34.3021C35.5535 34.5551 35.6956 34.8982 35.6956 35.256V42.5816ZM41.5777 42.5816C41.5777 42.9394 41.4355 43.2826 41.1825 43.5356C40.9295 43.7886 40.5864 43.9307 40.2286 43.9307C39.8708 43.9307 39.5276 43.7886 39.2746 43.5356C39.0216 43.2826 38.8795 42.9394 38.8795 42.5816V35.256C38.8795 34.8982 39.0216 34.5551 39.2746 34.3021C39.5276 34.0491 39.8708 33.9069 40.2286 33.9069C40.5864 33.9069 40.9295 34.0491 41.1825 34.3021C41.4355 34.5551 41.5777 34.8982 41.5777 35.256V42.5816Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    id: 2,
    title: "Support Local Businesses",
    description:
      "Contribute to your community by supporting local cafes and restaurants while discovering new dining options.",
    icon: (
      <svg
        width="75"
        height="75"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="37.6064" cy="37.3318" r="36.9418" fill="#3A7789" />
        <g clip-path="url(#clip0_1_1565)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.524 35.1564L36.9977 32.0143C37.7965 31.2931 38.7427 30.7542 39.7706 30.4351C40.7985 30.1159 41.8835 30.0242 42.9503 30.1661L47.5472 30.7748L53.9254 27.3284C54.0196 27.2773 54.1255 27.2517 54.2327 27.2539C54.3398 27.2561 54.4445 27.2862 54.5366 27.341C54.6286 27.3959 54.7048 27.4738 54.7577 27.567C54.8106 27.6602 54.8384 27.7655 54.8383 27.8727V39.5949C54.8383 39.9882 54.7444 40.3759 54.5646 40.7257C54.3847 41.0755 54.124 41.3774 53.8042 41.6063L49.5092 44.6767L44.8579 40.7775C45.7651 40.4513 46.5835 39.9176 47.2478 39.2188C47.389 39.0726 47.5 38.9001 47.5745 38.711C47.6489 38.5219 47.6854 38.3199 47.6819 38.1167C47.6783 37.9135 47.6348 37.713 47.5537 37.5266C47.4727 37.3403 47.3557 37.1717 47.2095 37.0305C47.0633 36.8893 46.8907 36.7783 46.7016 36.7039C46.5125 36.6294 46.3106 36.5929 46.1074 36.5965C45.9042 36.6 45.7037 36.6436 45.5173 36.7246C45.3309 36.8057 45.1623 36.9226 45.0211 37.0689C44.5659 37.5488 44.0282 37.8507 43.408 37.9744C42.8662 38.0808 42.1759 38.0634 41.3075 37.7962L40.2041 36.8685L37.1238 39.3648C36.5619 39.8098 35.8494 40.0197 35.136 39.9505C34.4226 39.8813 33.7638 39.5384 33.2978 38.9937C32.8319 38.449 32.5952 37.745 32.6374 37.0294C32.6796 36.3139 32.9974 35.6426 33.524 35.1564ZM31.4507 32.8604L33.9446 30.6065C32.872 30.3168 31.7493 30.2637 30.6541 30.4507L26.1141 31.2374L21.1313 28.5555C21.0351 28.5036 20.9271 28.4777 20.8178 28.4801C20.7085 28.4826 20.6018 28.5134 20.508 28.5695C20.4142 28.6256 20.3366 28.7051 20.2828 28.8003C20.229 28.8954 20.2008 29.0029 20.2011 29.1122V39.5924C20.2011 40.4287 20.6142 41.2105 21.3045 41.6806L34.8007 50.8817C35.6534 51.4641 36.6643 51.7709 37.6969 51.7607C38.7295 51.7506 39.7341 51.4239 40.5752 50.8248L46.7753 46.4234L40.1695 40.8814L39.0685 41.7672C37.8806 42.7218 36.3678 43.1765 34.8504 43.0349C33.3331 42.8933 31.9305 42.1666 30.9398 41.0086C29.9491 39.8506 29.4481 38.3525 29.543 36.8315C29.6379 35.3105 30.3238 33.8862 31.4507 32.8604Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_1565">
            <rect
              width="34.6373"
              height="34.6373"
              fill="white"
              transform="translate(20.201 22.1875)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: 3,
    title: "Exciting Surprises",
    description:
      "Experience the thrill of discovering unique mystery bags filled with a variety of delicious food items.",
    icon: (
      <svg
        width="75"
        height="75"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="37.6064" cy="37.3318" r="36.9418" fill="#3A7789" />
        <g clip-path="url(#clip0_1_1565)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.524 35.1564L36.9977 32.0143C37.7965 31.2931 38.7427 30.7542 39.7706 30.4351C40.7985 30.1159 41.8835 30.0242 42.9503 30.1661L47.5472 30.7748L53.9254 27.3284C54.0196 27.2773 54.1255 27.2517 54.2327 27.2539C54.3398 27.2561 54.4445 27.2862 54.5366 27.341C54.6286 27.3959 54.7048 27.4738 54.7577 27.567C54.8106 27.6602 54.8384 27.7655 54.8383 27.8727V39.5949C54.8383 39.9882 54.7444 40.3759 54.5646 40.7257C54.3847 41.0755 54.124 41.3774 53.8042 41.6063L49.5092 44.6767L44.8579 40.7775C45.7651 40.4513 46.5835 39.9176 47.2478 39.2188C47.389 39.0726 47.5 38.9001 47.5745 38.711C47.6489 38.5219 47.6854 38.3199 47.6819 38.1167C47.6783 37.9135 47.6348 37.713 47.5537 37.5266C47.4727 37.3403 47.3557 37.1717 47.2095 37.0305C47.0633 36.8893 46.8907 36.7783 46.7016 36.7039C46.5125 36.6294 46.3106 36.5929 46.1074 36.5965C45.9042 36.6 45.7037 36.6436 45.5173 36.7246C45.3309 36.8057 45.1623 36.9226 45.0211 37.0689C44.5659 37.5488 44.0282 37.8507 43.408 37.9744C42.8662 38.0808 42.1759 38.0634 41.3075 37.7962L40.2041 36.8685L37.1238 39.3648C36.5619 39.8098 35.8494 40.0197 35.136 39.9505C34.4226 39.8813 33.7638 39.5384 33.2978 38.9937C32.8319 38.449 32.5952 37.745 32.6374 37.0294C32.6796 36.3139 32.9974 35.6426 33.524 35.1564ZM31.4507 32.8604L33.9446 30.6065C32.872 30.3168 31.7493 30.2637 30.6541 30.4507L26.1141 31.2374L21.1313 28.5555C21.0351 28.5036 20.9271 28.4777 20.8178 28.4801C20.7085 28.4826 20.6018 28.5134 20.508 28.5695C20.4142 28.6256 20.3366 28.7051 20.2828 28.8003C20.229 28.8954 20.2008 29.0029 20.2011 29.1122V39.5924C20.2011 40.4287 20.6142 41.2105 21.3045 41.6806L34.8007 50.8817C35.6534 51.4641 36.6643 51.7709 37.6969 51.7607C38.7295 51.7506 39.7341 51.4239 40.5752 50.8248L46.7753 46.4234L40.1695 40.8814L39.0685 41.7672C37.8806 42.7218 36.3678 43.1765 34.8504 43.0349C33.3331 42.8933 31.9305 42.1666 30.9398 41.0086C29.9491 39.8506 29.4481 38.3525 29.543 36.8315C29.6379 35.3105 30.3238 33.8862 31.4507 32.8604Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_1565">
            <rect
              width="34.6373"
              height="34.6373"
              fill="white"
              transform="translate(20.201 22.1875)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];

const steps = [
  {
    id: 0,
    imageAlign: "right",
    imageSrc: "images/discover-mockup.png",
    title: "Discover Mystery Bags",
    questions: [
      {
        question: "Browse Local Options",
        answer:
          "Open the app to find mystery bags available at nearby stores and restaurants.",
      },
      {
        question: "Filter and Choose",
        answer:
          "Use filters to narrow down by food type, preferences, or pickup times, and view details on each bag.",
      },
    ],
  },
  {
    id: 1,
    imageAlign: "left",
    imageSrc: "images/payment-mockup.jpg",
    title: "Reserve and Pay",
    questions: [
      {
        question: "Select and Reserve",
        answer: `Pick your preferred mystery bag, confirm the details, and click "Reserve".`,
      },
      {
        question: "Secure Payment",
        answer:
          "Pay through the app using available payment options and receive a reservation confirmation.",
      },
    ],
  },
  {
    id: 2,
    imageAlign: "right",
    imageSrc: "images/taket-away-mockup.jpg",
    title: "Pick Up Your Bag",
    questions: [
      {
        question: "Go to Pickup Location",
        answer: `Arrive at the store at the specified time, and show your confirmation code to collect your bag.`,
      },
      {
        question: "Bring a Reusable Bag",
        answer: "To reduce waste, consider bringing your own bag.",
      },
    ],
  },
  {
    id: 3,
    imageAlign: "left",
    imageSrc: "images/enjoy-mockup.jpg",
    title: "Enjoy and Make a Difference",
    questions: [
      {
        question: "Unpack and Enjoy",
        answer: `Discover the surprise contents and enjoy fresh food.`,
      },
      {
        question: "Join the Movement",
        answer:
          "By using Surpeats, you help reduce food waste and make a positive impact.",
      },
    ],
  },
];

const accordionData = [
  {
    title: "What is Surpeats?",
    content: `Surpeats is an app dedicated to reducing food waste by connecting users with local stores, cafes, and restaurants that have surplus food. You can purchase surplus food at a discount, helping to save good food from going to waste and enjoying great value at the same time!`,
  },
  {
    title: "How does Surpeats work?",
    content: `Surpeats partners with various food businesses that offer their surplus food as "mystery bags" at a discounted price. Simply browse the available options, place your order, and pick it up at the designated time from the store. You’ll receive a surprise mix of items based on what's available!`,
  },
  {
    title: "What is a “mystery bag”?",
    content: `A mystery bag is a surprise selection of surplus food items provided by our partners. While you won’t know exactly what’s inside, you can be assured of its quality and freshness. Mystery bags offer great value for money and an element of surprise!`,
  },
  {
    title: "Why is Surpeats different from other food delivery apps?",
    content: `Unlike typical food delivery apps, Surpeats focuses on reducing food waste. We partner with
businesses to offer their unsold food at a discount, so you’re helping the planet by rescuing food that might  therwise be wasted.`,
  },
  {
    title: "What kind of food can I expect in the mystery bag?",
    content: `The contents of each mystery bag vary depending on the surplus available that day. You
may find bakery items, prepared meals, fresh produce, and more, depending on the partner
and the type of establishment.`,
  },
  {
    title: "Is the food safe and fresh?",
    content: `Absolutely! Surpeats only partners with reputable businesses that adhere to strict food safety
standards. All items are safe and fresh, provided in accordance with food safety regulations.`,
  },
];

export default function HowItWorks() {
  const newLocal = "Art board";
  return (
    <>
      <Helmet>
        <title>How it works</title>
      </Helmet>
      <HeroBanner
        showAppLogoInHeader={false}
        sectionClassName="py-32 lg:py-52"
        heroBannerImgUrl="images/how-it-works-banner.png"
        title={`Combat Food Waste One Mystery Bag at a Time – Learn How It Works!`}
        titleWrapperClassName="max-w-5xl mx-auto text-left lg:text-center"
      />
      <section className="container pt-6 pb-3 lg:pt-20 lg:pb-14 ">
        <div className="flex gap-7 items-center flex-col lg:gap-40 lg:flex-row">
          <img
            alt={newLocal}
            src="images/artboard.jpg"
            width={516}
            height={705}
            className=""
          />
          <div>
            <h2 className="text-3xl leading-snug mb-2.5 lg:pr-20 lg:mb-12 lg:text-4xl lg:leading-snug font-anton">
              Introducing the Surpeats Mystery Bag
            </h2>
            <p className="text-sm lg:text-base text-gray-100 lg:pr-7">
              Imagine scoring a surprise bundle of delicious food from your
              favourite local spots, packed with treats you didn’t even know you
              wanted—all for a fraction of the price! Surpeats’ *Mystery Bag*
              lets you rescue fresh, quality food that would otherwise go to
              waste, adding a little excitement to every meal while supporting
              sustainable choices. So, dive into the thrill of discovery, save
              money, and make an impact, one Mystery Bag at a time!
            </p>
          </div>
        </div>
      </section>
      <section className="container pt-3 pb-11 lg:pt-14 lg:pb-12">
        <h3 className="text-center relative block text-4xl leading-snug text-black font-anton underline decoration-4 lg:decoration-8 underline-offset-8 decoration-primary-200 mb-11 lg:text-5xl lg:mb-20">
          Advantages of Using Surpeats
        </h3>
        <ul className="flex gap-6 overflow-x-auto remove-scroll -mx-4 px-4 py-px lg:gap-11 lg:px-px lg:mx-0">
          {surpeatsAdvantages.map((item, index) => {
            return (
              <li
                className={`min-w-72 w-full p-8 rounded-3xl ring-1 ring-primary-200 ${
                  index === 0 ? "bg-primary-200 text-white" : ""
                }`}
              >
                <span className="block mb-1.5">{item.icon}</span>
                <h3 className="text-xl font-anton uppercase py-4">
                  {item.title}
                </h3>
                <p
                  className={`text-base line-clamp-4 ${
                    index === 0 ? "bg-primary-200 text-white" : "text-black/50"
                  }`}
                >
                  {item.description}
                </p>
              </li>
            );
          })}
        </ul>
      </section>
      <section className="container pt-10 space-y-16 lg:space-y-28 lg:pt-12 lg:pb-16">
        {steps.map((item, index) => {
          return (
            <div
              className={`flex items-center lg:gap-48 ${
                item.imageAlign === "right"
                  ? "flex-col lg:flex-row"
                  : "flex-col lg:flex-row-reverse"
              }`}
            >
              <div className="flex-1">
                <span className="inline-block px-6 py-2.5 rounded-full uppercase bg-primary-200 text-white text-4xl lg:text-6xl font-anton">
                  Step - {index + 1}
                </span>
                <h4 className="text-black font-anton mt-2 text-2xl lg:text-4xl">
                  {item.title}
                </h4>
                {item?.questions?.length > 0 && (
                  <ul className="mt-6 lg:mt-9">
                    {item.questions.map((item, index) => {
                      return (
                        <li
                          key={`question-${index}`}
                          className="text-base text-gray-100"
                        >
                          {item.question} : {item.answer}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
              <div className="relative mt-7">
                <div className="size-full bg-primary-200 absolute -z-10 lg:-left-10 lg:-top-10 rounded-lg" />
                <img
                  src={item.imageSrc}
                  alt={item.title}
                  width={466}
                  height={426}
                  className="aspect-square object-cover"
                />
              </div>
            </div>
          );
        })}
      </section>
      <AccordionLists accordionData={accordionData} />
      <Footer />
    </>
  );
}
